import { isGroupTableSelected } from 'owa-group-utils';
import { IsGroupsEnabled } from 'owa-group-feature-flags';
import { ComposeViewState } from 'owa-mail-compose-store';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function shouldAddinsPopulate(viewState: ComposeViewState): boolean {
    if (viewState.IRMData && viewState.IRMData.RmsTemplateId) {
        return false;
    } else if (IsGroupsEnabled() && isGroupTableSelected()) {
        return false;
    }
    return isFeatureEnabled('rp-addins');
}
